
<script setup>
import { Icon, Checkbox, Input, Label } from '@components'
import { watch } from 'vue'

import { useAppointments } from '@store/appointments.js'
const $appointments = useAppointments()

const props = defineProps({
    item: {
        type: Object
    }
})

const changeAppointmentType = (id) => {
    $appointments.setAppointment('appointment_type', props.item)

    $appointments.appointmentTypes.forEach(ap => {
        if (ap.id === id) return ap.checkbox = true

        ap.checkbox = false
    })

}
</script>
<template>
    <div>
        <div class="flex gap-4 p-4 rounded-lg" @click="changeAppointmentType(props.item.id)" :class="[props.item.checkbox ? 'bg-[#F9F5FF] rounded-lg border-2 border-[#7F56D9]' : 'border border-[#EAECF0] hover:border-[#D6BBFB]'], { 'rounded-[8px_8px_0_0]': props.item.checkbox && props.item.name === 'Home service' }">
            <Icon :name="props.item.icon" size="36px" class="rounded-full p-[4px] w-[32px] h-[32px] bg-[#F4EBFF] text-[#7F56D9] border-4 border-[#F9F5FF]"></Icon>
            <div class="flex justify-between w-full gap-1">
                <div>
                    <div class="text-base font-bold" :class="props.item.checkbox ? 'text-[#53389E]' : 'text-[#344054]'">{{ props.item.name }}</div>
                    <div class="text-sm font-normal" :class="props.item.checkbox ? 'text-[#6941C6]' : 'text-[#475467]'">{{ props.item.description }}</div>
                </div>
                <Checkbox v-model="props.item.checkbox" checkboxClass="rounded-[100%]" design="secondary"></Checkbox>
            </div>
        </div>
        <div v-if="props.item.checkbox && props.item.name === 'Home service'" class="p-4 border-2 border-t-0 border-[#7F56D9] rounded-[0_0_8px_8px]">
            <Label>Address</Label>
            <Input v-model="props.item.address" placeholder="Enter your address" class="mt-1.5" inputContainerClass="p-[8px_12px]"></Input>
        </div>
    </div>
</template>


<style>

</style>